<template>
  <div>
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">停车场分析</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label >
            <el-button @click="changeBtn('hour','24',0)" :class="{'btnc':activeind==0}">今天</el-button>
            <el-button @click="changeBtn('day','7',1)" :class="{'btnc':activeind==1}">7天</el-button>
            <el-button @click="changeBtn('day','30',2)" :class="{'btnc':activeind==2}">30天</el-button>
            <el-button @click="changeBtn('month','6',3)" :class="{'btnc':activeind==3}">6个月</el-button>
            <el-button @click="changeBtn('month','12',4)" :class="{'btnc':activeind==4}">今年</el-button>    
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">          
         <div class="topRow">
             <div class="topLeftEchart">
                 <p class="title">车流量走势</p>
                 <div style="width:100%;height:100%;"  id="echartParking0"></div>
             </div>
             <div class="topRightLine">
                  <p class="title">停留时长分布</p>
                <div style="width:100%;height:100%;"  id="zhuLine1"></div>
             </div>
         </div>
         <div class="topRow">
             <div class="topLeftEchart">
                  <p class="title">车流量时段分布</p>
                 <div style="width:100%;height:100%;"  id="zhuLine2"></div>
             </div>
             <!-- <div class="topRightLine">
                
             </div> -->
         </div>
         <div class="topRow">
           <div class="topLeftEchart">
            <p class="title">车源地Top10(省份)</p>
            <el-table :data="table" ref="multipleTable" border style="width: 100%" fixed>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="name" label="省份"></el-table-column>
              <el-table-column prop="count" label="数量"></el-table-column>
            </el-table>
           </div>
        </div>
         
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import { realParking, carTrendy, TimeDistribute,top10carResourceP,top10carResourceC } from '../../../../../../request/api';
const appConfig={
    targetPoi:{
        name:'天山天池',
        coords: [87.9236, 43.5883]
    },
    area:{
        name:"阜康市",
        code:"652302",
        type:3,
        areaType:1,
        weatherCityName:'阜康市',
        poi:'88.127965771,43.885640247',
        provinceCode:"650000"
    }
}
export default {
  name: "CarParkAnalysisList",
  controller: "UI",
  action: "CarParkAnalysisList",
    data(){
        return{
            areaType:appConfig.area.type,
            areaCode:appConfig.area.code,
            carTrendyDataX:[],
            carTrendyDataY:[],
            carTrendyDuration:[],
            table:[],
            activeind:0
        }
    },
    mounted(){
        // let that=this;
        // this.refreshData();
        // that.interval = setInterval(() => {
        //   that.refreshData();
        // }, 60000);
       this.changeBtn('hour','24',0);
    },
    methods:{
    changeBtn(type,value,index){
        this.activeind = index;
       this.getRealCarTrendy(type,value);
        this.getTimeDist(type,value);
        this.getTopPr(type,value);
     },
     getTopPr(type,value){
       let that = this;
       let params={
          "timeType": type,
          "timeValue": value,
       }
       top10carResourceP(params).then(res=>{
           console.log("res")
           console.log(res)
           that.table = res.data;
       })
     },
     getTimeDist(type,value){
        let that = this;
       let params={
            "timeType": type,
            "timeValue": value
        }
       TimeDistribute(params).then(res=>{
          let data = res.data;
          console.log("时段分布")
          console.log(data)
          if(data.length>0){
               let carTrendyDataX=[];
               let carTrendyDataY=[];
               let carTrendyDuration=[];
              data.forEach(item=>{
                 carTrendyDataX.push(item.dataTime);
                //  carTrendyDataY.push(item.countIn);
                 carTrendyDuration.push(item.duration); 
              })
            //   that.drawZhe(carTrendyDataX, carTrendyDataY,'0');
              that.initChartPie("zhuLine2",{
                        title: '车流量时段分布',
                        xAxis: carTrendyDataX,
                        series: carTrendyDuration
                    });
           }
       })
     },
    //  车流趋势
     getRealCarTrendy(type,value){
         let that = this;
       let params={
            "timeType": type,
            "timeValue": value
        }
       carTrendy(params).then(res=>{
           console.log("res")
           console.log(res)
           let data = res.data;
           if(data.length>0){
               let carTrendyDataX=[];
               let carTrendyDataY=[];
               let carTrendyDuration=[];
              data.forEach(item=>{
                 carTrendyDataX.push(item.dataTime);
                 carTrendyDataY.push(item.countIn);
                 carTrendyDuration.push(item.duration); 
              })
              that.drawZhe(carTrendyDataX, carTrendyDataY,'0');
              that.initChartPie("zhuLine1",{
                        title: '停留时长分布',
                        xAxis: carTrendyDataX,
                        series: carTrendyDuration
                    });
           }
           
       })
     },
     drawZhe(dataX,dataY,index){
         console.log(dataX)
         console.log(dataY)
         console.log(index)
      let _this=this;    
      let id = "echartParking"+index
      var myChart=echarts.init(document.getElementById(id));
      // console.log("myChart")
      // console.log(myChart)
        //指定图表的配置项和数据
      var option={
           tooltip: {
            trigger: 'axis'
        },
        grid: {
            left: '5%',
            right: '5%',
            top: '20%',
            bottom: '10%',
            containLabel: true
        },
        calculable: true,
        xAxis: [
            {
                type: 'category',
                name: '',
                nameTextStyle: {
                    color: '#9ab9ca',
                    //fontSize: 12
                },
                boundaryGap: false,
                axisLine: {
                    lineStyle: {
                        color: '#18396E'
                    }
                },
                axisLabel: {
                    textStyle: {
                        //fontSize: 12,
                        color: '#9ab9ca'
                    }
                },
                data: dataX
            }
        ],
        yAxis: [
            {
                type: 'value',
                name: '',
                nameTextStyle: {
                    color: '#9ab9ca',
                    padding: 0
                },
                axisLine: {
                    lineStyle: {
                        color: '#18396E'
                    }
                },
                axisLabel: {
                    textStyle: {
                        //fontSize: 12,
                        color: '#9ab9ca'
                    }
                },
                splitLine: {
                    show: false
                }
            }
        ],
        series: [
            {
                name: "",
                type: 'line',
                smooth: true,
                symbol: 'none',
                interval: true,
                itemStyle: {
                    normal: {
                        areaStyle: {
                            opacity: 0.2,
                            color: '#2CC8FF'
                        }
                    }
                },
                markPoint: {
                    symbol: 'circle',
                    symbolSize:5,
                    itemStyle: {
                        normal: {
                            label: {
                                show: true,
                                fontSize: 1,
                                color: '#2CC8FF'
                            }
                        }
                    },
                    data: [{
                        type: 'max',
                        name: '最大值'
                    }]
                },
                lineStyle: {
                    normal: {
                        width: 1
                    }
                },
                color: ['#2CC8FF'],
                data: dataY
            }
        ]
        };
        //使用刚刚指定的配置项和数据项显示图表
        myChart.setOption(option);
    } ,
     // 初始化柱状图
   initChartPie(chartObj,data){
     var myChart = echarts.init(document.getElementById(chartObj));
     var option = {
              // 标题
		     title: {
		            text: "",
		            subtext:'',
		            left:'left',
		            borderColor:'',
		            borderWidth:""
		        },
		        tooltip:{
		            trigger:'axis'
		        },
		        // 图例
		        legend: {
		            data: ['count']
		        },
		        // x轴
		        xAxis: {
		            data: data.xAxis
		        },
		        yAxis: {},
		        // 数据
		        series: [{
		            name: 'count',
		            type: 'bar',
		            data: data.series,
		            markPoint:{
		                data:[
		                    {type:'max',name:'最大值'},
		                    {type:'min',name:'最小值',symbol:'arrow'}
		                ]
		            }
		        }
		        ]
		    };
            myChart.setOption(option, true);
        },
  
    },
    destroyed(){
        // clearInterval(this.interval);
    }
}
</script>
<style lang="scss" scoped>
.topRow{
    width:100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top:30px;
  .topLeftEchart{
       width:50%;
       height:36rem;
  } 
  .topRightLine{
      width:50%;
      height:36rem;
  } 
  .title{
    font-size: 1.8rem;
    font-weight: bold;
    text-align: left;
    padding-left: 3rem;
  }
}
.btnc{
    background: #298beb !important;
}

</style>